import { agwputil } from '@ktag/styleguide/dist/platform';
import { DateFormatter } from 'ewp-common';
import environment from '../config/environment';

const searchAddress = (searchText: string) => {
  const url = `https://api3.geo.admin.ch/rest/services/ech/SearchServer?lang=de&type=locations&limit=10&origins=address&searchText=${searchText}`;

  return fetch(url, {
    method: 'GET',
    headers: {},
  }).then(res => res.json());
};

const prepareReturnUrl = (status) => {
  const url = new URL(document.location.href);
  // const documentId = url.searchParams.get('reference') ??
  url.searchParams.set('reference', 'documentId');
  url.searchParams.set('status', status);
  return url.href;
};

const prepareReqDataForCreateOrder = (data) => {
  const {
    amountData,
    formData: {
      personal,
      deliveryInfo,
    },
    paymentMethod,
    paymentCollectionType,
    deliveryType
  } = data;

  const paymentData = {
    ...amountData,
    successRedirectUrl: prepareReturnUrl('success'),
    failedRedirectUrl: prepareReturnUrl('failed'),
    cancelRedirectUrl: prepareReturnUrl('cancel'),
  };

  const {
    fieldAnrede,
    fieldName,
    fieldFirstname,
    fieldAhvNumber,
    fieldDob,
    fieldStrasse,
    fieldNr,
    fieldPlz,
    fieldOrt,
    fieldLand,
    fieldPhone,
    fieldEmail,
    fieldLockType,
    uploadfield,
    fieldRemarks
  } = personal;

  return {
    formRequest: {
      personal: {
        fieldAnrede,
        fieldName,
        fieldFirstname,
        fieldAhvNumber,
        fieldDob: DateFormatter.formatDateForOutput(fieldDob),
        fieldStrasseNr: `${fieldStrasse} ${fieldNr}`,
        fieldPlzOrt: `${fieldPlz} ${fieldOrt}`,
        fieldLand,
        fieldPhone,
        fieldEmail,
        fieldLockType,
        uploadfield,
        fieldRemarks,
        link:personal.link
      },
      fieldDeliveryInfo: {
        fieldDeliveryAddressDifferent: deliveryInfo.fieldDeliveryAddressDifferent,
        fieldDeliveryCompany: deliveryInfo.fieldDeliveryCompany,
        fieldDeliveryLastname: deliveryInfo.fieldDeliveryLastname,
        fieldDeliveryFirstname: deliveryInfo.fieldDeliveryFirstname,
        fieldDeliveryStrasseNr: `${deliveryInfo.fieldStrasse} ${deliveryInfo.fieldNr}`,
        fieldDeliveryPlzOrt: `${deliveryInfo.fieldPlz} ${deliveryInfo.fieldOrt}`,
        fieldDeliveryLand: deliveryInfo.fieldLand,
      },
      municipalityId: data.formData?.municipalityId,
      fieldPaymentType: paymentMethod?.paymentCode === '3' || process.env.REACT_APP_USE_NEW_PAYMENT_AND_DELIVERY_METHOD == "1" ? paymentCollectionType : paymentMethod?.paymentCode ,
      fieldDeliveryType: paymentMethod?.deliveryCode === '3' || process.env.REACT_APP_USE_NEW_PAYMENT_AND_DELIVERY_METHOD == "1" ? deliveryType : paymentMethod?.deliveryCode

    },
    paymentRequest: paymentData,
  };
};

const createOrder = (reqData) => {
  const url = `${environment.baseURL}createform/v1/datalock`;

  return agwputil.authenticatedFetch(url, {
    method: 'POST',
    headers: {
      // 'Ocp-Apim-Subscription-Key': 'c1b9a607435d4cef9deb8ff77d629cb7',
    },
    body: JSON.stringify(prepareReqDataForCreateOrder(reqData)),
  });
};

const parseFieldStrasseNrResponse = (fieldStrasseNr) => {
  let fieldNr;
  let fieldStrasse;
  const fieldStrasseNrArr = fieldStrasseNr?.split(' ') ?? [];
  if (fieldStrasseNrArr.length > 1) {
    fieldNr = fieldStrasseNrArr?.[fieldStrasseNrArr?.length - 1];
    fieldStrasse = fieldStrasseNrArr.slice(0, fieldStrasseNrArr?.length - 1).join(' ');
  } else {
    fieldStrasse = fieldStrasseNrArr?.[0] ?? '';
    fieldNr = '';
  }

  return {
    fieldStrasse,
    fieldNr,
  };
};

const parseFieldPlzOrtResponse = (fieldPlzOrt) => {
  const [fieldPlz, fieldOrt] = fieldPlzOrt?.split(' ') ?? [];
  return {
    fieldPlz,
    fieldOrt,
  };
};

const parseOrderDetailsResponse = (res) => {
  const { formRequest, ...rest } = res;
  const {
    personal,
    fieldDeliveryInfo,
    fieldPaymentType,
    fieldDeliveryType,
    municipalityId,
  } = formRequest;

  const formData = {
    personal: {
      ...personal,
      ...parseFieldStrasseNrResponse(personal.fieldStrasseNr),
      ...parseFieldPlzOrtResponse(personal.fieldPlzOrt),
      fieldDob: DateFormatter.formatDateForInput(personal.fieldDob)
    },
    deliveryInfo: {
      ...fieldDeliveryInfo,
      ...parseFieldStrasseNrResponse(fieldDeliveryInfo.fieldDeliveryStrasseNr),
      ...parseFieldPlzOrtResponse(fieldDeliveryInfo.fieldDeliveryPlzOrt),
      fieldLand: fieldDeliveryInfo.fieldDeliveryLand,
    },
  };

  return {
    ...rest,
    formData,
    fieldPaymentType,
    fieldDeliveryType,
    municipalityId,
  };
};

const fetchOrderDetails = (documentId) => {
  const url = `${environment.baseURL}createform/v1/getFormData`;
  const body = {
    documentId,
  };

  return agwputil.authenticatedFetch(url, {
    method: 'POST',
    headers: {
      // 'Ocp-Apim-Subscription-Key': 'c1b9a607435d4cef9deb8ff77d629cb7',
    },
    body: JSON.stringify(body),
  })
    .then(res => res.json())
    .then((data) => {
      if (data?.message) {
        throw new Error(data?.message);
      }

      return data;
    })
    .then((data) => {
      if (data) {
        return parseOrderDetailsResponse(data);
      }
      return '';
    })
    .catch((e) => {
      /* eslint-disable no-console */
      console.warn(e);
    });
};

export default {
  fetchOrderDetails,
  createOrder,
  searchAddress,
};
